/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useDispatch, useSelector } from 'react-redux';
import { setPageNo } from '../../features/filter/filterSlice';

export default function Pagination() {
    const splitIntoChunksOfLen = (toalSize, chunkSize) => {
        const el = [1];
        let sizeCount = 1;
        for (let i = chunkSize; i < toalSize; i += chunkSize) {
            ++sizeCount;
            el.push(sizeCount);
        }
        return el;
    };

    const dispatch = useDispatch();
    const { totalVideos } = useSelector((state) => state.videosCount);

    const { pageNo } = useSelector((state) => state.filter);
    const pagesArray = splitIntoChunksOfLen(totalVideos, 4);

    const handlePaginate = (page) => {
        dispatch(setPageNo(page));
    };

    return (
        <section className="pt-12">
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
                {pagesArray.map((page) => (
                    <div
                        onClick={() => handlePaginate(page)}
                        key={page}
                        className={`px-4 py-1 rounded-full cursor-pointer ${
                            pageNo === page
                                ? ' bg-blue-600 text-white'
                                : 'bg-blue-100 text-blue-600'
                        }`}
                    >
                        {page}
                    </div>
                ))}
            </div>
        </section>
    );
}
